import { Injectable, Injector } from "@angular/core";
import { InBoxListView } from "../../../Data/WebTraderData/InBoxListView";
import { QueryNodeMessageBox } from "../QueryNodeMessageBox";
import { QueryConditionNodeInbox } from "./QueryConditionNodeInbox";
import { FieldDefinitionConditions } from "../../../../../sections/webtrader/webtrader/message/fieldDefinition-conditions";
import { ResultListNodeInbox } from "../ListEntity/ResultListNodeInbox";
import { EntityEnum } from "../../EntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";


@Injectable({
  providedIn: 'root',
})
export class QueryNodeInBox extends QueryNodeMessageBox {

  constructor(injector: Injector) {
    super(injector, new InBoxListView([]), 'Inbox', EntityEnum.inb, ServiceEnum.Webtrader);
    this.children!.push(new QueryConditionNodeInbox(injector, new FieldDefinitionConditions(injector).queryInboxConditions));
    this.children!.push(new ResultListNodeInbox(injector));
  }

  override reset(): void {
    this.children = [];
    this.children!.push(new QueryConditionNodeInbox(this.ioc!, new FieldDefinitionConditions(this.ioc!).queryInboxConditions));
    this.children!.push(new ResultListNodeInbox(this.ioc!));   
  }

}